import { render, staticRenderFns } from "./total_units_vs_cpu.vue?vue&type=template&id=23b77b70&scoped=true"
import script from "./total_units_vs_cpu.vue?vue&type=script&lang=js"
export * from "./total_units_vs_cpu.vue?vue&type=script&lang=js"
import style0 from "./total_units_vs_cpu.vue?vue&type=style&index=0&id=23b77b70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b77b70",
  null
  
)

export default component.exports